/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as tsx from 'vue-tsx-support';
import HelpHomepageLink from '@/components/HelpHomepageLink';
import { SiteSettingsStore } from '@/store';
export default tsx.component({
    name: 'footer-bar',
    functional: true,
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render() {
        const version = SiteSettingsStore.releaseInfo().mapOrDefault(r => r.version ?? `#${r.commit.substring(0, 7)}`, '...');
        const roadmapUrl = 'https://codegrade.com/roadmap';
        const aboutUrl = 'https://www.codegrade.com/company/about-us';
        const privacyUrl = 'https://www.codegrade.com/privacy-policy';
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const footerLink = (href, text) => (<a href={href} target="_blank">
                {text}
            </a>);
        return (<footer class="footer w-full px-6 py-4! text-center text-sm text-balance">
                &copy; {new Date().getFullYear()} - CodeGrade ({footerLink(roadmapUrl, version)}) -{' '}
                {footerLink(aboutUrl, 'Made with ❤️')} -{' '}
                {footerLink(privacyUrl, 'Privacy statement')} - <HelpHomepageLink />
            </footer>);
    },
});
